import React from "react";
import { Link } from "react-router-dom";
import { Clock, Copy, ArrowUpRight, Info } from "lucide-react";
import DashboardLayout from "../components/dashboard/DashboardLayout";

const History = () => {
  return (
    <DashboardLayout title="Trade history" subtitle="All closed trades" activeKey="history">
      <div className="grid sm:grid-cols-4 gap-4 mb-5">
        <div className="bb-card rounded-2xl p-5">
          <div className="text-[11px] text-white/55 mb-1">Total trades</div>
          <div className="font-display text-[24px] font-bold">0</div>
        </div>
        <div className="bb-card rounded-2xl p-5">
          <div className="text-[11px] text-white/55 mb-1">Win rate</div>
          <div className="font-display text-[24px] font-bold text-white/55">—</div>
          <div className="text-[11px] text-white/45 mt-1">No closed trades yet</div>
        </div>
        <div className="bb-card rounded-2xl p-5">
          <div className="text-[11px] text-white/55 mb-1">Best trade</div>
          <div className="font-display text-[24px] font-bold text-white/55 tabular-nums">—</div>
        </div>
        <div className="bb-card rounded-2xl p-5">
          <div className="text-[11px] text-white/55 mb-1">Net result</div>
          <div className="font-display text-[24px] font-bold tabular-nums text-white/55">$0.00</div>
        </div>
      </div>

      <div className="bb-card rounded-2xl p-8 lg:p-12 text-center" data-testid="history-empty">
        <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-white/[0.04] border border-white/8 flex items-center justify-center">
          <Clock size={22} className="text-white/55" />
        </div>
        <div className="font-display font-bold text-[20px] text-white mb-2">
          No trade history yet
        </div>
        <p className="text-[13px] text-white/55 max-w-md mx-auto leading-relaxed mb-6">
          Closed trades will appear here once you start copying a trader or once manual trading goes live. Track every win, loss, and net P&amp;L.
        </p>
        <Link
          to="/dashboard/copy-trading"
          className="inline-flex items-center gap-1.5 px-4 py-2.5 bb-blue text-white text-[13px] font-medium rounded-lg"
          data-testid="history-copy-cta"
        >
          <Copy size={14} /> Start copying <ArrowUpRight size={14} />
        </Link>

        <div className="mt-8 max-w-md mx-auto flex items-start gap-2.5 px-4 py-3 rounded-lg bg-white/[0.02] border border-white/8 text-left">
          <Info size={14} className="text-[#7d8eff] shrink-0 mt-0.5" />
          <div className="text-[11px] text-white/55 leading-relaxed">
            CSV export and detailed filters unlock once you have closed trades.
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default History;
